import script from "./TasksModalV2.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksModalV2.vue?vue&type=script&setup=true&lang=js"

import "./TasksModalV2.vue?vue&type=style&index=0&id=77fecfc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77fecfc4"]])

export default __exports__